module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"skills":"Key skills required","FAQ":"FAQ","address":"Address","published":"Job published"}}')
  delete Component.options._Ctor
}
